const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m16.79.25-12.47 11a1.06 1.06 0 0 0 0 1.54l12.47 11a1 1 0 0 0 .73.25 1 1 0 0 0 .69-.36l1.55-1.85a1 1 0 0 0 .24-.74 1 1 0 0 0-.35-.69l-9.45-8.21a.27.27 0 0 1 0-.38l9.45-8.17A1 1 0 0 0 20 3a1 1 0 0 0-.23-.74L18.21.36a1 1 0 0 0-.69-.36 1 1 0 0 0-.73.25Z" fill="currentColor"></path></svg>';
export {
  a as default
};
